module.exports = __webpack_public_path__ + "img/class3.702372d8.png";